import { render, staticRenderFns } from "./JcdcHeadline.vue?vue&type=template&id=86039fd0&scoped=true"
import script from "./JcdcHeadline.vue?vue&type=script&lang=ts"
export * from "./JcdcHeadline.vue?vue&type=script&lang=ts"
import style0 from "./JcdcHeadline.vue?vue&type=style&index=0&id=86039fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86039fd0",
  null
  
)

export default component.exports